/* eslint-disable import/no-named-as-default */
// #region Imports
import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@material-ui/core/Box';

import ENDPOINTS from '../../consts/endpoints';
import ScreenLoader from '../../containers/ScreenLoader';
import api from '../../library/api';
import { getParameterByName } from '../../library/utils';
import { isValidToken } from '../../utils/validations/custom-validations';

// #endregion

function LoginOAuthBBApp() {
  const handleLoader = useRef();
  const navigate = useNavigate();

  const handleToken = useCallback(async () => {
    const token = getParameterByName('tokenbb');

    if (isValidToken(token)) {
      handleLoader.current.handleControl();

      await api
        .get(ENDPOINTS.LOGIN_BB_APP(token), { noAuthorization: true })
        .then(({ data }) => {
          if (data.status === 'OK') {
            const URI = ENDPOINTS.PORTAL_BB_SEGUROS(
              encodeURI(data.resultado?.token),
            );
            window.location.href = URI;
          }
        })
        .catch(() => {
          navigate('/home');
        });
    } else {
      navigate('/home');
    }
  }, [navigate]);

  useEffect(() => {
    handleToken();
  }, [handleToken]);

  return (
    <>
      <Box height="100vh" width="100vw" bgcolor="#fae128" />
      <ScreenLoader ref={handleLoader} />
    </>
  );
}

export default LoginOAuthBBApp;
